import { useState } from "react"
import Icon from '../Assets/IconDxpay.svg'
import qrCode from '../Assets/icons/qrCodeIcon.svg'
import axiosInstance from "../Services/Api"
import TwoFactorModalLogin from "./twoFactorModalLogin"
import { useAuth } from "../Contexts/AuthContext"
const GoogleAuthenticatorComponent = ({setAuthenticationOpen,setTwoFactorActive}) => {
    const [showQrCode, setShowQrcode] = useState(false)
    const [qrCodeUrl, setQrCodeUrl] = useState(null)
    const [secret, setSecret] = useState(null)
    const { setTwofa, tokenRefs,setWrongCode } = useAuth();
    const Habilitar2fa = async () => {
        try {
            const response = await axiosInstance.post('/api/set2fa')
            setShowQrcode(true)
            setQrCodeUrl(response.data.qrCodeUrl)
            setSecret(response.data.secret)

        } catch (e) {
            if(e.status === 401){
                window.localStorage.removeItem('token')
                window.location.href='/#/login'
            }
           
        }
    }

    const confirmToken = async () => {
        try {
            let tokenTwo = ""
            tokenRefs.current.forEach(element => {
                tokenTwo += element.value
            });
            if (tokenTwo !== "") {
                const response = await axiosInstance.post('/api/verify2Fa', {
                    token:tokenTwo
                })
                alert('authenticação configurada  com sucesso')
                setAuthenticationOpen(false)
                setTwoFactorActive(true)
            } else {

            }
        } catch (e) {

            if(e.status = 401){
                setWrongCode(true)
            }
        }
    }
    return (
        <div>
            {showQrCode ?
                <div className="">
                    <div className="flex relative gap-4 px-4 mt-8  w-full">
                        <div className="w-[50%]">
                            <h1 className="text-[14px]">Conclua a ativação da autenticação de dois fatores.</h1>
                            <p className="text-[12px] mt-4">
                                Para concluir a ativação da autenticação de dois fatores, digitalize o seguinte código QR usando o aplicativo autenticador do seu telefone ou insira a chave de configuração e forneça o código OTP gerado.
                                Chave de configuração {secret}

                                <div className="mt-4">
                                    <img width={180} src={qrCodeUrl} alt="QR Code for otp" />
                                </div>

                                <div onClick={() => { setTwofa(true) }} className="px-3 relative z-[99999] mt-4 py-1 w-[180px] cursor-pointer flex gap-3 rounded-[12px] bg-[#478DF8]">
                                    <img src={qrCode} />
                                    confirmar e terminar
                                </div>
                            </p>
                        </div>
                        <img width={'50%'} src={Icon} />
                        <TwoFactorModalLogin confirmMode={true} confirm={confirmToken} />
                    </div>
                </div>
                :
                <div className="px-4 relative z-[99999] mt-8">
                    <div className="flex gap-4  w-ful">
                        <div className="w-[50%]">
                            <h1 className="text-[14px]">Você não ativou a autenticação de dois fatores.</h1>
                            <p className="text-[12px] mt-4">
                                Quando a autenticação de dois fatores estiver ativada,
                                você será solicitado a fornecer um token seguro e aleatório durante a autenticação.
                                Você pode usar aplicativos autenticadores em seu smartphone, como Google Authenticator,
                                Microsoft Authenticator, etc., para facilitar isso
                                <div onClick={Habilitar2fa} className="px-3 mt-4 py-1 w-[120px] cursor-pointer flex gap-3 rounded-[12px] bg-[#478DF8]">
                                    <img src={qrCode} />
                                    Habilitar
                                </div>
                            </p>
                        </div>
                        <img width={'50%'} src={Icon} />
                    </div>
                </div>

            }


        </div>

    )
}

export default GoogleAuthenticatorComponent